export default __webpack_public_path__ + "static/research-89ae18963790269228dc1686ebe1a174.jpg";